import {PageBaseSection} from "../PageBaseSection";

export class PageContextSection extends PageBaseSection{
  list_contexts: PageContextSectionLine[];
}

export enum ContextTriggers {
  WEEKEND = "weekend",
  RAINY = "rainy",
  WINDY = "windy",
  SUNNY = "sunny",
  CLOUDY = "cloudy",
  EVENING = "evening",
  IMPORTANT = "important",
  SUNDAY = "sunday"
}

export class PageContextSectionLine {
  icon: number;
  tabname: string;
  title: string;
  is_disabled: boolean;
  active: boolean;
  introduction: string;
  pages: number[];
  selection_sit: string;
  filtres_sit: string;
  trigger: ContextTriggers[]
  tri: number = 0
}
